var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 22.4753H16.1562V18.5482H20.25V16.343H16.1562V12.3857H13.875V16.343H9.78125V18.5482H13.875V22.4753ZM6.8125 27.0669C6.20833 27.0669 5.67708 26.8454 5.21875 26.4023C4.76042 25.9593 4.53125 25.4457 4.53125 24.8617V4.1388C4.53125 3.55477 4.76042 3.04123 5.21875 2.59818C5.67708 2.15512 6.20833 1.93359 6.8125 1.93359H17.9688L25.4688 9.15339V24.8617C25.4688 25.4457 25.2396 25.9593 24.7812 26.4023C24.3229 26.8454 23.7917 27.0669 23.1875 27.0669H6.8125ZM16.8438 10.1805V4.1388H6.8125V24.8617H23.1875V10.1805H16.8438ZM6.8125 4.1388V10.1805V4.1388V24.8617V4.1388Z",
    fill: "#1C4C96"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.885d00f33ed9443ed2bcfcc348b1d131.svg";
export { ForwardRef as ReactComponent };